<template>
  <div class="form-detail">
    <h1>Lịch sử ký</h1>
    <div class="table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="thead-light">
          <tr>
            <th scope="col" class="text-left">HĐ/ Số phụ lục</th>
            <th scope="col" class="text-left">Ngày ký</th>
            <th scope="col" class="text-left">Sales</th>
            <th scope="col" class="text-left">Người duyệt</th>
            <th scope="col" class="text-left">Thao tác</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="index">
          <tr class="table-row">
            <td align="left">{{ item.code }}</td>
            <td align="left">{{ item.dateSign | formatDate('HH:mm, DD/MM/YYYY') }}</td>
            <td align="left">
              <p>{{ item.nameSale }}</p>
              <p>{{ item.emailSale }}</p>
            </td>
            <td align="left">
              <p>{{ item.namePerform }}</p>
              <p>{{ item.emailPerform }}</p>
            </td>
            <td align="left">
              <p>
                {{ item.typeAction | fomatTypeHistory }}
              </p>
              <p>{{ item.datePerform | formatDate('HH:mm, DD/MM/YYYY') }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  export default {
    props: ['contractId'],
    data() {
      return {
        items: [],
      }
    },
    async created() {
      this.items = await ContractService.getSignHistory(this.contractId).then(s => s.data ?? [])
    },

    methods: {},
  }
</script>

<style scoped></style>
